(function () {
  'use strict';

  var BLOCKED_PROPS = ['oncopy', 'oncut', 'onselectstart', 'oncontextmenu', 'ondragstart'];
  var GUARD_EVENTS = ['copy', 'cut', 'selectstart', 'contextmenu'];

  function clearInlineHandlers(root) {
    if (!root) return;
    BLOCKED_PROPS.forEach(function (prop) {
      try {
        root[prop] = null;
      } catch (error) {
        /* ignore */
      }
    });
  }

  function sealInlineHandlers(root) {
    if (!root) return;
    BLOCKED_PROPS.forEach(function (prop) {
      try {
        Object.defineProperty(root, prop, {
          configurable: true,
          get: function () {
            return null;
          },
          set: function () {
            /* ignore anti-copy reinjection */
          }
        });
      } catch (error) {
        clearInlineHandlers(root);
      }
    });
  }

  function installEventGuards() {
    GUARD_EVENTS.forEach(function (eventName) {
      window.addEventListener(
        eventName,
        function (event) {
          event.stopPropagation();
        },
        true
      );
    });
  }

  function unlockTextSelection() {
    [document, document.documentElement, document.body].forEach(function (node) {
      clearInlineHandlers(node);
      sealInlineHandlers(node);
    });
  }

  unlockTextSelection();
  installEventGuards();

  document.addEventListener('DOMContentLoaded', unlockTextSelection);
  window.addEventListener('load', function () {
    unlockTextSelection();
    window.setTimeout(unlockTextSelection, 500);
    window.setTimeout(unlockTextSelection, 2000);
  });
})();
